import React from 'react'
import MobileDrawer from '../MobileComponents/MobileDrawer'
import ForumIcon from '@mui/icons-material/Forum';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import { blue } from '@mui/material/colors';
import MobileMarketPlaceTab from './MobileMarketPlaceTab';
import Product1 from '../../assets/images/LapTop1.jpg';
import Product2 from '../../assets/images/HeadPhone.jpg';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { useNavigate } from 'react-router-dom';
import resipro from '../../assets/images/resiproIcon.svg';

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


function MobileMarketPlaceBuyer() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className='mainwrapperView'>
    <div className="drawerWithTop">
        <MobileDrawer />
        <div className="EventTimeView">
          <img src={resipro} className="HeaderlogoImage" alt='altimg'/>
          <h2 className="mobHeadHeading">Park Side Apartment</h2>
        </div>
    </div>
    <div className='topSpace'></div>
    <div className='MarketPlaceHeaderView'>
        <p className='MarketPlaceTxt'>Market Place</p>
        <ForumIcon sx={{ color: '#005aff', fontSize: 25 }} onClick={()=>navigate('/MobileChatList')} />
    </div>
    <div className='MarketBtnSearchView flexEnd'>
      <input type='text' placeholder='Location' className='MarketSearchInput'/>
    </div>
    <div className='SearchSortDivTab paddingInlineView'>
      <input type='text' placeholder='Search' />
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 0 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <SortOutlinedIcon sx={{ fontSize: 30, color: blue[800] }} />
      </IconButton>
      <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleClose}>
            Oldest to Newest
          </MenuItem>
          <MenuItem onClick={handleClose}>
            Newest to Oldest
          </MenuItem>
      </Menu>
    </div>
    <div className='ProductListView'>
      <p className='PrdMainTxt'>Product List</p>
      <div className='PrdListView'>
      <div className='prodctListBox' onClick={()=>navigate('/MobileMarketDetailsBuyer')}>
        <img src={Product1} className='ProdImg' alt='ProductImg'/>
        <p className='ProdPrice'><CurrencyRupeeIcon sx={{fontSize:16}} />777.00</p>
        <p className='ProdName'>Product Name</p>
        <div className='PrdctChatIconView'>
          <ForumIcon sx={{fontSize:18, color:'white'}}/>
        </div>
      </div>
      <div className='prodctListBox' onClick={()=>navigate('/MobileMarketDetailsBuyer')}>
        <img src={Product2} className='ProdImg' alt='ProductImg' />
        <p className='ProdPrice'><CurrencyRupeeIcon sx={{fontSize:16}}  /> 777.00</p>
        <p className='ProdName'>Product Name</p>
        <div className='PrdctChatIconView'>
          <ForumIcon sx={{fontSize:18, color:'white'}}/>
        </div>
      </div>
      <div className='prodctListBox' onClick={()=>navigate('/MobileMarketDetailsBuyer')}>
        <img src={Product1} className='ProdImg' alt='ProductImg'/>
        <p className='ProdPrice'><CurrencyRupeeIcon sx={{fontSize:16}} />777.00</p>
        <p className='ProdName'>Product Name</p>
        <div className='PrdctChatIconView'>
          <ForumIcon sx={{fontSize:18, color:'white'}}/>
        </div>
      </div>
      <div className='prodctListBox' onClick={()=>navigate('/MobileMarketDetailsBuyer')}>
        <img src={Product2} className='ProdImg' alt='ProductImg' />
        <p className='ProdPrice'><CurrencyRupeeIcon sx={{fontSize:16}}  /> 777.00</p>
        <p className='ProdName'>Product Name</p>
        <div className='PrdctChatIconView'>
          <ForumIcon sx={{fontSize:18, color:'white'}}/>
        </div>
      </div>
      <div className='prodctListBox' onClick={()=>navigate('/MobileMarketDetailsBuyer')}>
        <img src={Product1} className='ProdImg' alt='ProductImg'/>
        <p className='ProdPrice'><CurrencyRupeeIcon sx={{fontSize:16}} />777.00</p>
        <p className='ProdName'>Product Name</p>
        <div className='PrdctChatIconView'>
          <ForumIcon sx={{fontSize:18, color:'white'}}/>
        </div>
      </div>
      <div className='prodctListBox' onClick={()=>navigate('/MobileMarketDetailsBuyer')}>
        <img src={Product2} className='ProdImg' alt='ProductImg' />
        <p className='ProdPrice'><CurrencyRupeeIcon sx={{fontSize:16}}  /> 777.00</p>
        <p className='ProdName'>Product Name</p>
        <div className='PrdctChatIconView'>
          <ForumIcon sx={{fontSize:18, color:'white'}}/>
        </div>
      </div>
      </div>
    </div>
    <MobileMarketPlaceTab />
    </div>
  )
}

export default MobileMarketPlaceBuyer